import { baseApi } from "./baseApi";
import { AppSettingsTypeEnum } from "../../enums";

export const appSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppSettings: builder.query<any, AppSettingsTypeEnum>({
      query: (type) => ({ url: `/api/app-settings/${type}` }),
      providesTags: ["AppSettings"],
    }),
    updateAppSettings: builder.mutation<
      any,
      { type: AppSettingsTypeEnum; data: any }
    >({
      query: ({ type, data }) => ({
        url: `/api/app-settings/${type}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["AppSettings"],
    }),
    generateSequenceNumber: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/app-settings/generate-sequence-number",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAppSettingsQuery,
  useLazyGetAppSettingsQuery,
  useUpdateAppSettingsMutation,
  useGenerateSequenceNumberMutation,
} = appSettingsApi;
